import * as React from 'react';

export const NotSelected = () => (<span>NotSelected</span>);
